<template>
  <div class="floor-ad" v-if="ad">
    <img v-lazy="ad.adv_code" @click="goAdUrl(ad)" />
  </div>
</template>

<script>
export default {
  name: "IndexFloorAds",
  data() {
    return {};
  },
  props: ["ad"],
  methods: {
    goAdUrl(item) {
      this.$router.push({ path: item.adv_typedate });
    },
  },
};
</script>

<style scoped lang="scss">
.floor-ad {
  // background: #fff;
  padding-left: $pageSpace;
  padding-right: $pageSpace;
  padding-bottom: $modelSpace;
}
.floor-ad img {
  width: 100%;
  border-radius: 0.4rem;
}
</style>
